export const DATAGRID_ALLOWED_PAGE_SIZES = [5, 10, 50];
export const ALLOWED_PAGE_SIZES = [5, 10, 50];

export const DATAGRID_DEFAULT_PAGE_SIZE = 5;
export const DATAGRID_ALLOWED_FILTER_OPERATIONS = ['contains'];
export const DG_FILTER_EQUALS_TO_OPERATION = ['='];
export const ALLOWED_FILE_FORMATS = ["image/png", "image/jpeg", "image/jpg", "webp", "application/pdf"];
export const ALLOWED_IMAGE_FORMATS = ["image/png", "image/jpeg", "image/jpg", "image/ico",
      "image/x-icon",        // ✅ Correct MIME type for ICO
 "webp", 
   "image/webp",

 "application/pdf"];
export const QD_UNIT_GRAM_VALUE = 13
export const QD_UNIT_NUMBER_VALUE = 11
export const DG_HEADER_FILTER_TRANSACTION_TYPE_DATA_SOURCE = [
    { text: 'خرید', value: 'خرید' },
    { text: 'فروش', value: 'فروش' },
    {text: 'خرید حضوری', value: 'خرید حضوری'},
    {text: 'فروش حضوری', value: 'فروش حضوری'},
    {text: 'خرید تلفنی', value: 'خرید تلفنی'},
    {text: 'فروش تلفنی', value: 'فروش تلفنی'},
    {text: 'پرداخت', value: 'پرداخت'},
    {text: 'دریافت', value: 'دریافت'},
]

export const DG_HEADER_FILTER_TRANSACTION_ORDER_TYPE_DATA_SOURCE = [
    { text: 'سیستمی', value: 'سیستمی' },
    { text: 'حضوری', value: 'حضوری' },
    { text: 'تلفنی', value: 'تلفنی' },
]

export const DG_HEADER_FILTER_IS_APPROVED_DATA_SOURCE = [
    { text: 'تایید', value: 'تایید' },
    { text: 'رد', value: 'رد' },
]

export const DG_HEADER_FILTER_QD_UNIT_DATA_SOURCE = [
    { text: 'عدد', value: 11 },
    { text: 'گرم', value: 13 },
]

export const QD_UNITS = [
    { text: 'عدد', value: QD_UNIT_NUMBER_VALUE },
    { text: 'گرم', value: QD_UNIT_GRAM_VALUE },
]
